






























































import Vue from 'vue'
import Component from 'vue-class-component'
import {Getter, Mutation, State} from 'vuex-class'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType'
import {notify} from '@/modules/core/notification'

/**
 * Componente lista/detalle de los tipos de eventos de calendario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class CalendarEventTypeMasterDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            update: (field: string, value: any) => void,
        },
    }

    /**
     * Lista de tipos de eventos de calendario
     */
    @State(state => state.calendar.calendarEventTypes)
    public types: CalendarEventType[]

    @Mutation('calendar/SET_CURRENT_CALENDAR_EVENT_TYPE')
    public selectCalendarEventType: (event: CalendarEventType) => void

    /**
     * Tipo de evento de calendario
     */
    @State(state => state.calendar.currentCalendarEventType)
    public currentType: CalendarEventType

    @Getter('calendar/eventTypeHasEvents')
    public eventTypeHasEvents: (type: CalendarEventType) => boolean

    public get typeHasEvents (): boolean {
        return this.eventTypeHasEvents(this.currentType)
    }

    /**
     * Cabeceras de la tabla
     */
    public headers = [
        { value: 'id', text: 'Identificador'},
        { value: 'name', text: 'Nombre del evento'},
        { value: 'key', text: 'Clave'},
        { value: 'nonworking', text: 'No laborable'},
    ]

    /**
     * Alto de la tabla que muestra la lista de eventos
     */
    get tableHeight () {
        return this.$vuetify.breakpoint.xlOnly ? '700px' : '500px'
    }

    /**
     * Estilos calculador para la pantalla de edición de la categoría
     */
    get detailCardStyles () {
        return {
            height: this.$vuetify.breakpoint.xlOnly ? '598px' : '400px',
            // height: '400px',
            overflow: 'auto',
        }
    }

    public creating = false
    public saving = false
    public deleting = false

    public get nonworking () {
        return this.currentType.nonworking
    }

    public set nonworking (val: boolean) {
        this.$refs.form.update('nonworking', val)
    }

    public createNewCalendarEventType () {
        this.selectCalendarEventType(new CalendarEventType())
        this.creating = true
    }

    /**
     * Guarda los cambios realizado sobre el tipo de evento de calendario
     */
    public async save () {
        this.saving = true
        try {
            await this.$store.dispatch('calendar/saveCalendarEventType')
        } catch (e) {
            notify(`Se ha producido un error: ${e.message}`)
        }

        this.creating = this.saving = false
    }

    /**
     * Elimina el tipo de evento de calendario actualmente en edición por el usuario
     */
    public async remove () {
        this.deleting = true
        try {
            await this.$store.dispatch('calendar/deleteCalendarEventType')
        } catch (e) {
            notify(`Se ha producido un error: ${e.message}`)
        }

        this.deleting = false
    }
}
